// The drag payload. `index` is mutated in place while hovering, exactly as the open-task list
// does, so a long drag does not re-search the list on every mouse move.
export interface SubTicketDragItem {
    subTicketId: ID;
    index: number;
}

// Scoped to this list on purpose: a sub-task must never be droppable on the client task board
export const SUB_TICKET_DND_TYPE = 'task-sub-ticket-row';
